import { ThemeProvider } from "@mui/material";
import { PageWrapper } from "@src/appV2/redesign/components/PageWrapper";
import { getTheme } from "@src/appV2/redesign/system/ui-theme";

import { CaseHistoryContent } from "./Content";

export function CaseHistoryPage() {
  return (
    <ThemeProvider theme={getTheme()}>
      <PageWrapper variant="tertiary">
        <CaseHistoryContent />
      </PageWrapper>
    </ThemeProvider>
  );
}
